<template>
	<div class="contains management">
		<div class="content-main">
			<div class="client">
				<div class="tag">
					<div class="tag-li on">客户筛选</div>
					<!-- <span class="shu"></span>
					<div class="tag-li">客户群</div>-->
				</div>
				<div class="radio">
					<div>
						<el-radio v-model="radio" label="1">用户行为</el-radio>
					</div>
				</div>
				<div class="checkbox">
					<el-checkbox label="姓名" v-model="IsShow.show6" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show6">
						<el-input v-model="SelectModel.NickName" placeholder="请输入姓名 " @input="Select_Management"></el-input>
					</div>

					<el-checkbox label="手机号" v-model="IsShow.show7" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show7">
						<el-input v-model="SelectModel.Mobile" placeholder="请输入手机号" @input="Select_Management"></el-input>
					</div>

					<el-checkbox label="邮箱" v-model="IsShow.show8" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show8">
						<el-input v-model="SelectModel.Email" placeholder="请输入邮箱" @input="Select_Management"></el-input>
					</div>

					<el-checkbox label="地址" v-model="IsShow.show1" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show1">
						<el-select
							placeholder="选择省"
							v-model="SelectModel.Province"
							@change="S_City1(SelectModel.Province)"
						>
							<el-option
								v-for="item in option22"
								:key="item.provinceID"
								:label="item.provinceName"
								:value="item.provinceID"
							></el-option>
						</el-select>
						<el-select
							placeholder="选择市"
							v-model="SelectModel.City"
							@change="S_District1(SelectModel.City)"
						>
							<el-option
								v-for="item in option33"
								:key="item.cityID"
								:label="item.cityName"
								:value="item.cityID"
							></el-option>
						</el-select>
						<el-select placeholder="选择区" v-model="SelectModel.District">
							<el-option
								v-for="item in option44"
								:key="item.districtID"
								:label="item.districtName"
								:value="item.districtID"
							></el-option>
						</el-select>
						<el-input
							@input="Select_Management"
							type="textarea"
							v-model="SelectModel.Detailed_address"
							class="input textarea"
							placeholder="请输入内容"
							resize="none"
							maxlength="100"
							show-word-limit
						></el-input>
					</div>
					<el-checkbox label="标签" v-model="IsShow.show2" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show2">
						<el-select placeholder="客户标签" v-model="SelectModel.Lable_id" @change="Select_Management()">
							<el-option
								v-for="item in option5"
								:key="item.id"
								:label="item.label_Name"
								:value="item.label_id"
							></el-option>
						</el-select>
					</div>

					<el-checkbox label="负责人" v-model="IsShow.show3" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show3">
						<el-select placeholder="所有负责人" v-model="SelectModel.User_id" @change="Select_Management()">
							<el-option v-for="item in option1" :key="item.id" :label="item.nickName" :value="item.id"></el-option>
						</el-select>
					</div>

					<el-checkbox label="创建时间" v-model="IsShow.show4" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show4">
						<el-date-picker
							@input="Select_Management"
							v-model="SelectModel.CreateTime"
							type="date"
							placeholder="开始时间"
							style="width: 80%;"
						></el-date-picker>
						<el-date-picker
							@input="Select_Management"
							v-model="SelectModel.CreateTime1"
							type="date"
							placeholder="结束时间"
							style="width: 80%;"
						></el-date-picker>
					</div>
					<el-checkbox label="更新时间" v-model="IsShow.show5" @change="Select_Management()"></el-checkbox>
					<div class="div_Select" v-if="IsShow.show5">
						<el-date-picker
							@input="Select_Management"
							v-model="SelectModel.UpdateTime"
							type="date"
							placeholder="开始时间"
							style="width: 80%;"
						></el-date-picker>
						<el-date-picker
							@input="Select_Management"
							v-model="SelectModel.UpdateTime1"
							type="date"
							placeholder="结束时间"
							style="width: 80%;"
						></el-date-picker>
					</div>

					<!-- <el-checkbox label="地址" ></el-checkbox>
                <el-checkbox label="标签" ></el-checkbox>
                <el-checkbox label="负责人" ></el-checkbox>
                <el-checkbox label="创建时间" ></el-checkbox>
                <el-checkbox label="更新时间" ></el-checkbox>
                <el-checkbox label="首次会话时间" ></el-checkbox>
                <el-checkbox label="最后一次会话时间" ></el-checkbox>
                <el-checkbox label="首次电话联系时间" ></el-checkbox>
                <el-checkbox label="最后一次电话联系时间" ></el-checkbox>
					<el-checkbox label="访客备注" ></el-checkbox>-->
				</div>
				<!-- <el-button type="primary" class="save">查询</el-button> -->
			</div>

			<el-dialog title="修改客户" :visible.sync="dialogVisible" width="30%">
				<div class="dialog">
					<div class="section">
						<span class="label">手机</span>
						<div class="input_box">
							<el-input placeholder="请输入内容" class="input" v-model="UpdateModel.Mobile"></el-input>
						</div>
						<div class="clear"></div>
					</div>

					<div class="section">
						<span class="label">昵称</span>
						<div class="input_box">
							<el-input placeholder="请输入内容" class="input" v-model="UpdateModel.NickName"></el-input>
						</div>
						<div class="clear"></div>
					</div>

					<div class="section">
						<span class="label">姓名</span>
						<div class="input_box">
							<el-input placeholder="请输入内容" class="input" v-model="UpdateModel.RealName"></el-input>
						</div>
						<div class="clear"></div>
					</div>

					<div class="section">
						<span class="label">邮箱</span>
						<div class="input_box">
							<el-input placeholder="请输入内容" class="input" v-model="UpdateModel.Email"></el-input>
						</div>
						<div class="clear"></div>
					</div>

					<div class="section">
						<span class="label">负责人</span>
						<div class="input_box">
							<el-select placeholder="所有负责人" v-model="UpdateModel.User_id">
								<el-option v-for="item in option1" :key="item.id" :label="item.nickName" :value="item.id"></el-option>
							</el-select>
						</div>
						<div class="clear"></div>
					</div>

					<div class="section">
						<span class="label">地址</span>
						<div class="input_box">
							<el-select
								placeholder="选择省"
								v-model="UpdateModel.Province"
								@change="S_City(UpdateModel.Province)"
							>
								<el-option
									v-for="item in option2"
									:key="item.provinceID"
									:label="item.provinceName"
									:value="item.provinceID"
								></el-option>
							</el-select>
							<el-select
								placeholder="选择市"
								v-model="UpdateModel.City"
								@change="S_District(UpdateModel.City)"
							>
								<el-option
									v-for="item in option3"
									:key="item.cityID"
									:label="item.cityName"
									:value="item.cityID"
								></el-option>
							</el-select>
							<el-select placeholder="选择区" v-model="UpdateModel.District">
								<el-option
									v-for="item in option4"
									:key="item.districtID"
									:label="item.districtName"
									:value="item.districtID"
								></el-option>
							</el-select>
						</div>
						<div class="clear"></div>
					</div>
					<div class="section">
						<span class="label">详情地址</span>
						<div class="input_box">
							<el-input
								type="textarea"
								v-model="UpdateModel.Detailed_address"
								class="input textarea"
								placeholder="请输入内容"
								resize="none"
								maxlength="100"
								show-word-limit
							></el-input>
						</div>

						<div class="clear"></div>
					</div>
					<div class="section">
						<span class="label">客户标签</span>
						<div class="input_box" style="margin-bottom: 10px;">
							<el-select
								v-model="MiniChannelEnumModel"
								multiple
								placeholder="请选择"
								style="    width: 98%;"
								@change="aa"
							>
								<el-option
									v-for="item in option5"
									:key="item.label_id"
									:label="item.label_Name"
									:value="item.label_id"
								></el-option>
							</el-select>
						</div>
					</div>
					<br />
					<br />
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="Close">取 消</el-button>
					<!-- <el-button type="primary" @click="Add"  >确 定</el-button> -->
					<el-button type="primary" @click="UpdateConsultantInfo">修改</el-button>
				</span>
			</el-dialog>

			<div class="content">
				<div class="table_box">
					<el-table
						ref="multipleTable"
						:data="tableData"
						tooltip-effect="dark"
						style="width: 100%;"
						border
						stripe
						@selection-change="handleSelectionChange"
						@select-all="select_all"
						@select="select"
					>
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column fixed prop="name" label="姓名" width="155"></el-table-column>
						<el-table-column prop="tel" label="手机"></el-table-column>
						<el-table-column prop="email" label="邮箱"></el-table-column>
						<el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
						<el-table-column label="标签">
							<template slot-scope="scope">
								<div class="lables">
									<span
										:key="index"
										v-bind:style="{background:item.label_Color}"
										v-for="(item,index) in  scope.row.lable "
									>{{item.label_Name}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="charge" label="负责人"></el-table-column>
						<el-table-column prop="create_time" label="创建时间"></el-table-column>
						<el-table-column prop="update_time" label="更新时间"></el-table-column>

						<el-table-column fixed="right" label="操作" width="80">
							<template slot-scope="scope">
								<el-tooltip class="item" effect="dark" content="修改" placement="top-start">
									<i class="el-icon-edit" @click="UpdateShow(scope.row.count)" style="cursor: pointer;"></i>
								</el-tooltip>
								<el-tooltip class="item" effect="dark" content="删除" placement="top-start">
									<i class="el-icon-delete" style="cursor: pointer;" @click="Delete(scope.row.count)"></i>
								</el-tooltip>
								<el-tooltip class="item" effect="dark" content="导出历史聊天记录">
									<i class="el-icon-download" style="cursor: pointer;" @click="exportModel(scope.row)"></i>
								</el-tooltip>
								<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
								<el-button type="text" size="small">编辑</el-button>-->
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination">
					<el-pagination
						@current-change="List"
						:page-size="10"
						background
						layout="total, prev, pager, next"
						:total="SumUser"
					></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog
			title="导出聊天记录"
			:visible.sync="centerDialogVisible"
			:close-on-click-modal="false"
			width="30%"
			center
		>
			<div
				style="width:100%;text-align: center;"
				v-loading="exportLoading"
				element-loading-text="正在处理..."
			>
				<el-date-picker
					v-model="exportTime"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd"
				></el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="exportRecord" :loading="exportLoading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'management',
	props: [],
	data() {
		return {
			MiniChannelEnumModel: [], //客户标签
			UpdateModel: {
				Id: 0,
				Mobile: '',
				NickName: '',
				RealName: '',
				Email: '',
				Province: 1,
				City: 1,
				District: 1,
				Detailed_address: '',
				User_id: 1,
				CreateTime: '2020-1-4',
				UpdateTime: '2020-1-4'
			},
			SelectModel: {
				Id: 0,
				Mobile: '',
				NickName: '',
				RealName: '',
				Email: '',
				Province: 1,
				City: 1,
				District: 1,
				Detailed_address: '',
				User_id: 1,
				CreateTime: '',
				CreateTime1: '',
				UpdateTime: '',
				UpdateTime1: '',
				Lable_id: '',
				Detailed_address: ''
			},
			SumUser: 0,
			radio: '1',
			checkList: [],
			dialogVisible: false,
			tableData: [
				{
					count: 1,
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄',
					tel: '15383113709',
					email: '694446960@qqq.com',
					charge: '客服01',
					lable: [
						{
							name: 'a1',
							class: 'blue'
						},
						{
							name: 'b1',
							class: 'red'
						}
					],
					create_time: '10-10 12:12',
					update_time: '10-10 12:12',
					operate: '未处理'
				}
			],
			option1: [],
			option2: [],
			option3: [],
			option4: [],
			option5: [], //客户标签
			IsShow: {
				show1: false,
				show2: false,
				show3: false,
				show4: false,
				show5: false,
				show6: false, //姓名
				show7: false, //手机
				show8: false //邮箱
			},
			option22: [],
			option33: [],
			option44: [],
			exportId: '', //当前导出人的Id
			exportTime: [], //当前导出人的时间范围
			centerDialogVisible: false, //导出聊天记录的模态框
			exportLoading: false,
			exportName: ''
		}
	},
	watch: {},
	mounted: function() {},
	created: function() {
		this.Total()
		this.List()
		this.Show()
	},
	methods: {
		Show() {
			let $this = this
			this.axios
				.get('User/Select', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.option1 = data.data
					$this.S_Province()
					$this.S_Province1()
				})

			$this.axios
				.get('ConsultantInfo_Label/Select', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.option5 = data.data
				})
		},
		S_Province() {
			let $this = this
			this.axios
				.get('S_Province/Select', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.option2 = data.data
					$this.S_City($this.option2[0].provinceID)
					$this.UpdateModel.Province = $this.option2[0].provinceID
				})
		},
		S_City(Province_id) {
			let $this = this
			this.axios
				.get(
					'S_City/Select',
					{
						params: {
							ProvinceId: Province_id
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data1) {
					$this.option3 = data1.data
					$this.S_District($this.option3[0].cityID)
					$this.UpdateModel.City = $this.option3[0].cityID
				})
		},
		S_District(City_id) {
			let $this = this
			this.axios
				.get(
					'S_District/Select',
					{
						params: {
							CityId: City_id
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data2) {
					$this.option4 = data2.data
					$this.UpdateModel.District = $this.option4[0].districtID
				})
		},
		S_Province1() {
			let $this = this
			this.axios
				.get('S_Province/Select', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.option22 = data.data
					$this.S_City1($this.option22[0].provinceID)
					$this.SelectModel.Province = $this.option22[0].provinceID
				})
		},
		S_City1(Province_id) {
			let $this = this
			this.axios
				.get(
					'S_City/Select',
					{
						params: {
							ProvinceId: Province_id
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data1) {
					$this.option33 = data1.data
					$this.S_District1($this.option33[0].cityID)
					$this.SelectModel.City = $this.option33[0].cityID
				})
		},
		S_District1(City_id) {
			let $this = this
			this.axios
				.get(
					'S_District/Select',
					{
						params: {
							CityId: City_id
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data2) {
					$this.option44 = data2.data
					$this.SelectModel.District = $this.option44[0].districtID

					$this.Select_Management()
				})
		},
		UpdateShow(id) {
			let $this = this
			$this.dialogVisible = true
			this.axios
				.get('ConsultantInfo/UpdateModel?Id=' + id, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					console.log(data.data)
					if (data.data.province != 0 && data.data.province != null) {
						//alert(data.data.province)
						$this.S_City(data.data.province)
						$this.S_District(data.data.city)
					}

					$this.UpdateModel.Id = data.data.id
					$this.UpdateModel.Mobile = data.data.mobile
					$this.UpdateModel.NickName = data.data.nickName
					$this.UpdateModel.RealName = data.data.realName
					$this.UpdateModel.Email = data.data.email

					$this.UpdateModel.Province =
						data.data.province == 0 ? '' : data.data.province
					$this.UpdateModel.City =
						data.data.city == 0 ? '' : data.data.city
					$this.UpdateModel.District =
						data.data.district == 0 ? '' : data.data.district
					$this.UpdateModel.User_id =
						data.data.user_Id == 0 ? '' : data.data.user_Id

					//

					$this.UpdateModel.Detailed_address =
						data.data.detailed_Address
				})

			// MiniChannelEnumModel
			$this.MiniChannelEnumModel = []
			this.axios
				.get(
					'ConsultantInfoLabel_Relation/Update_Label?consultantInfo_id=' +
						id,
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					data.data.forEach(element => {
						$this.MiniChannelEnumModel.push(element.label_id)
					})
				})
		},
		Total() {
			//初始化  客户总人数
			let $this = this

			var Label = 0
			var Province = 0
			var City = 0
			var District = 0
			var Detailed_address = ''
			var User_id = 0
			var CreateTime = ''
			var CreateTime1 = ''
			var UpdateTime = ''
			var UpdateTime1 = ''
			var NickName = ''
			var Mobile = ''
			var Email = ''

			if ($this.IsShow.show1) {
				Province = $this.SelectModel.Province
				City = $this.SelectModel.City
				District = $this.SelectModel.District
				Detailed_address = $this.SelectModel.Detailed_address
			}

			if ($this.IsShow.show2) {
				Label = $this.SelectModel.Lable_id
			}

			if ($this.IsShow.show3) {
				User_id = $this.SelectModel.User_id
			}

			if ($this.IsShow.show4) {
				CreateTime = $this.SelectModel.CreateTime
				CreateTime1 = $this.SelectModel.CreateTime1
			}

			if ($this.IsShow.show5) {
				UpdateTime = $this.SelectModel.UpdateTime
				UpdateTime1 = $this.SelectModel.UpdateTime1
			}
			if ($this.IsShow.show6) {
				NickName = $this.SelectModel.NickName
			}
			if ($this.IsShow.show7) {
				Mobile = $this.SelectModel.Mobile
			}
			if ($this.IsShow.show8) {
				Email = $this.SelectModel.Email
			}
			this.axios
				.get(
					'ConsultantInfo/Sum',
					{
						params: {
							Label: Label,
							Province: Province,
							City: City,
							District: District,
							Detailed_address: Detailed_address,
							User_id: User_id,
							CreateTime: CreateTime,
							CreateTime1: CreateTime1,
							UpdateTime: UpdateTime,
							UpdateTime1: UpdateTime1,
							NickName: NickName,
							Mobile: Mobile,
							Email: Email
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.SumUser = data.data
				})
		},
		getDateStr5(seconds) {
			var date = new Date(seconds)
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()

			var hour =
				date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var minute =
				date.getMinutes() < 10
					? '0' + date.getMinutes()
					: date.getMinutes()
			var second =
				date.getSeconds() < 10
					? '0' + date.getSeconds()
					: date.getSeconds()
			var currentTime =
				year +
				'-' +
				month +
				'-' +
				day +
				'   ' +
				hour +
				':' +
				minute +
				':' +
				second
			return currentTime
		},
		List(PageSize, PageNum) {
			PageNum = 10
			let $this = this

			var Label = 0
			var Province = 0
			var City = 0
			var District = 0
			var Detailed_address = ''
			var User_id = 0
			var CreateTime = ''
			var CreateTime1 = ''
			var UpdateTime = ''
			var UpdateTime1 = ''
			var NickName = ''
			var Mobile = ''
			var Email = ''

			if ($this.IsShow.show1) {
				Province = $this.SelectModel.Province
				City = $this.SelectModel.City
				District = $this.SelectModel.District
				Detailed_address = $this.SelectModel.Detailed_address
			}

			if ($this.IsShow.show2) {
				Label = $this.SelectModel.Lable_id
			}

			if ($this.IsShow.show3) {
				User_id = $this.SelectModel.User_id
			}

			if ($this.IsShow.show4) {
				CreateTime = $this.SelectModel.CreateTime
				CreateTime1 = $this.SelectModel.CreateTime1
			}

			if ($this.IsShow.show5) {
				UpdateTime = $this.SelectModel.UpdateTime
				UpdateTime1 = $this.SelectModel.UpdateTime1
			}
			if ($this.SelectModel.Lable_id == '') {
				$this.SelectModel.Lable_id = $this.option5[0]
			}

			if ($this.IsShow.show6) {
				NickName = $this.SelectModel.NickName
			}
			if ($this.IsShow.show7) {
				Mobile = $this.SelectModel.Mobile
			}
			if ($this.IsShow.show8) {
				Email = $this.SelectModel.Email
			}

			this.axios
				.get(
					'ConsultantInfo/List',
					{
						params: {
							pages: PageSize,
							pageNum: PageNum,
							Label: Label,
							Province: Province,
							City: City,
							District: District,
							Detailed_address: Detailed_address,
							User_id: User_id,
							CreateTime: CreateTime,
							CreateTime1: CreateTime1,
							UpdateTime: UpdateTime,
							UpdateTime1: UpdateTime1,
							NickName: NickName,
							Mobile: Mobile,
							Email: Email
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.tableData = []
					data.data.forEach(element => {
						if (element.provinceName == null) {
							element.provinceName = ''
						}
						if (element.cityName == null) {
							element.cityName = ''
						}
						if (element.districName == null) {
							element.districName = ''
						}
						if (element.detailed_address == null) {
							element.detailed_address = ''
						}

						$this.tableData.push({
							count: element.id,
							name: element.names,
							address:
								element.provinceName +
								element.cityName +
								element.districName +
								element.detailed_address,
							tel: element.mobile,
							email: element.email,
							charge: element.nickName,
							create_time: $this.getDateStr5(
								element.createTime.replace('T', ' ')
							),
							update_time:
								element.updateTime == null
									? ''
									: $this.getDateStr5(
											element.updateTime.replace('T', ' ')
									  ),
							operate: '未处理',
							lable: element.list,
							miniOpenid: element.miniOpenid
						})
					})
				})
		},
		select_all(row) {
			//全选
		},
		select(row) {
			//选中某行
		},
		handleSelectionChange() {
			//选项发生变化
		},
		//修改
		UpdateConsultantInfo() {
			let $this = this
			var booleam = true

			if ($this.UpdateModel.User_id == '') {
				//alert('请选择负责人!')
				$this.$message.error('请选择负责人!')
				return
			}

			if (booleam) {
				this.axios
					.post('ConsultantInfo/Update', $this.UpdateModel, {
						headers: {
							'Content-Type': 'application/json'
						}
					})
					.then(function(data) {
						if (data.data.message == '成功') {
							if (
								$this.MiniChannelEnumModel != null &&
								$this.MiniChannelEnumModel != [] &&
								$this.MiniChannelEnumModel != ''
							) {
								$this.axios
									.post(
										'ConsultantInfoLabel_Relation/Delete?consultantInfo_id=' +
											$this.UpdateModel.Id,
										{
											headers: {
												'Content-Type':
													'application/json'
											}
										}
									)
									.then(function(data1) {
										if (data1.data.message == '成功') {
											$this.axios
												.post(
													'ConsultantInfoLabel_Relation/Add_Label?Lis=' +
														$this.MiniChannelEnumModel +
														'&consultantInfo_id=' +
														$this.UpdateModel.Id,
													{
														headers: {
															'Content-Type':
																'application/json'
														}
													}
												)
												.then(function(data2) {
													if (
														data2.data.message ==
														'成功'
													) {
														 
														$this.$message(data.data.message)
														$this.Total()
														$this.List()
														$this.Show()
														$this.dialogVisible = false
													} else {
														// alert(
														// 	data2.data.message
														// )
														$this.$message.error(data2.data.message)
													}
												})
										} else {
											 
											$this.$message.error(data1.data.message)
										}
									})
							} else {
							 
								$this.$message('成功')
								$this.Total()
								$this.List()
								$this.Show()
								$this.dialogVisible = false
							}
						} else {
						 
							$this.$message.error(data.data.message);
						}
					})
			}
		},
		Delete(id) {
			let $this = this
			var mymessage = confirm('是否删除？')
			if (mymessage == true) {
				this.axios
					.post('ConsultantInfo/Delete?Id=' + id, {
						headers: {
							'Content-Type': 'application/json'
						}
					})
					.then(function(data) {
						if (data.data.message == '成功') {
						 
							$this.$message(data.data.message);
							$this.Total()
							$this.List()
							$this.Show()
						} else {
							$this.$message(data.data.message);
						}
					})
			} else {
			}
		},
		Close() {
			let $this = this
			$this.dialogVisible = false
		},
		//查询
		Select_Management() {
			let $this = this

			// if($this.SelectModel.Lable_id==0){
			//       $this.SelectModel.Lable_id=$this.option5[0];
			// }

			$this.List()
			$this.Total()
		},
		aa() {},
		exportModel(obj) {
			this.exportId = obj.miniOpenid
			this.exportName = obj.name
			this.centerDialogVisible = true
		},
		exportRecord() {
			let vm = this
			vm.exportLoading = true
			vm.axios
				.post(
					'Dialogue/ExportDialogue',
					{
						consultId: vm.exportId,
						startTime: vm.exportTime[0],
						endTime: vm.exportTime[1]
					},
					{ responseType: 'blob' }
				)
				.then(function({ data }) {
					let filename = `用户：${vm.exportName}-${vm.exportTime[0]}_${vm.exportTime[1]}_会话记录.xls`
					let blob = data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
						vm.exportLoading = false
						vm.$message({ type: 'success', message: '导出成功' })
						vm.exportTime = []
						vm.centerDialogVisible = false
					}
				})
		}
	}
}
</script>

<style scoped>
.div_Select {
	padding: 10px;
	background: #f5f5f5;
	text-align: center;
	border: solid 1px #ddd;
}
.content-main {
	display: flex;
	position: relative;
	/* height: calc(100% - 60px);*/
	height: 100%;
}
.client {
	width: 190px;
	text-align: left;
	border-right: solid 1px #ddd;
	border-left: solid 1px #ddd;
	overflow-x: hidden;
	min-width: 190px;
	position: relative;
}
.tag {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: center;
	border-bottom: 1px solid #ddd;
}
.shu {
	width: 1px;
	height: 15px;
	background-color: #ddd;
}
.tag-li {
	width: 49%;
	text-align: center;
	line-height: 40px;
	cursor: pointer;
}
.tag-li.on {
	color: #409eff;
}
.radio {
	padding-top: 10px;
}
.radio > div {
	padding: 8px 15px;
}
.management .el-checkbox {
	display: block;
	padding-left: 15px;
	margin: 20px 0;
}
.save {
	position: absolute;
	bottom: 20px;
	left: 40px;
}
.lables span {
	display: inline-block;
	padding: 0 3px;
	height: 20px;
	line-height: 20px;
	font-size: 12px;
	color: #fff;
	margin: 0 3px 0 0;
	border-radius: 3px;
}
.blue {
	background-color: #ccdb38;
}
.red {
	background-color: #6ed0c7;
}
.content {
	padding: 20px;
	width: 100%;
}
.table_box {
	margin-top: 50px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
.label {
	float: left;
	width: 120px;
	text-align: right;
	margin-right: 20px;
}
.section {
	line-height: 50px;
	margin-top: 10px;
}
.input_box {
	float: left;
	width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/client/management.vue